import { render, staticRenderFns } from "./LegalGroup.vue?vue&type=template&id=0e1d6b17&scoped=true&"
import script from "./LegalGroup.vue?vue&type=script&lang=js&"
export * from "./LegalGroup.vue?vue&type=script&lang=js&"
import style0 from "./LegalGroup.vue?vue&type=style&index=0&id=0e1d6b17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d6b17",
  null
  
)

export default component.exports